import request from "@/utils/request";
import configR from '@/configs.js';
const API = configR.envConfigs.PORTAL_API;
// 获取服务标签
export function getServiceTagList(data) {
  return request({
    url: `${API}v1/service/tag/list?code=${data.code}&type=true`,
    method: "get",
    headerType: data.header
  });
}
//获取最近服务
export function getRecentListN(data) {
  return request({
    url: `${API}v1/service/lastUse/list?serviceType=${configR.envConfigs.SHOW_SERVICEAPP_SET_URL||"1,2,3"}`,
    method: "get",
    header: data.header,
  });
}
// 推荐使用
export function getRecommendList(data) {
  return request({
    url: `${API}v1/service/recommend/month/list?showPublic=false?type=1,2,3`,
    method: "get",
    headerType: data.header
  });
}
//获取服务列表
export function getServiceListN(data) {
  return request({
    url: `${API}v1/service/list?kw=${data.keyWord}&showPublic=${data.showPublic}&returnType=label`,
    method: "post",
    data: data.data || {},
    params: data.params || {},
    header: data.header,
  });
}
//获取服务列表
export function getServiceListNV2(data) {
  return request({
    url: `${API}v2/service/serviceShowAll?keyWord=${data.keyWord}&showPublic=${data.showPublic}&returnType=label&showType=${data.showType}&my=${data.my}&serviceType=${configR.envConfigs.SHOW_SERVICEAPP_SET_URL||"1,2,3"}`,
    method: "post",
    data: data.data || {},
    params: data.params || {},
    header: data.header,
  });
}
// 获取用户收藏的服务或应用
export function getCollectionService(data) {
  return request({
    url: `${API}v1/service/collect/list?reqType=label`,
    method: "get",
    headerType: data.header
  });

}
export function getServiceDetails(data) {
  return request({
    url: `${API}v1/service/manage/backSaveServiceInfo?serviceId=${data}`,
    method: "get",
    headerType: data.header
  });
}